import { m } from 'motion/react';
import React from 'react';
import { itemVariants } from '../../../utils/framer';
import KIAImage from '../ui/image/KIAImage';

interface TestimonyProps {
  imageSrc: string;
  altText: string;
  name: string;
  title: string;
  testimony: string;
}

export const Testimony: React.FC<TestimonyProps> = ({
  imageSrc,
  altText,
  name,
  title,
  testimony,
}) => {
  return (
    <m.div
      variants={itemVariants}
      className="w-full p-4 flex flex-col md:flex-row md:p-6 md:px-10 md:mb-10 md:mt-10 items-center bg-white md:rounded-lg"
    >
      <div className="flex w-full md:justify-end md:w-1/3">
        <div className="h-28 ml-4 mr-4 md:ml-0 md:h-44">
          <KIAImage
            src={imageSrc}
            alt={altText}
            className="object-contain object-center w-full h-full"
          />
        </div>

        <div className="md:hidden self-end">
          <p className="font-bold text-sm">{name}</p>
          <p className="text-gray-600">{title}</p>
        </div>
      </div>

      <div className="w-full md:w-2/3 p-4 md:p-2 flex flex-col gap-4">
        <p className="md:text-sm text-gray-800 italic">{testimony}</p>

        <div className="hidden md:block">
          <p className="font-bold text-base">{name}</p>
          <p className="text-gray-600">{title}</p>
        </div>
      </div>
    </m.div>
  );
};
